//import { lazy } from 'react'
import { lazy } from 'react'
import { getUserData } from '@src/auth/utils'
import Dashboard from '@src/views/pages/Dashboard'
import NotificationsPage from '@src/views/pages/NotificationsPage'

// ** Document title
const TemplateTitle = 'Wetu'

// ** Default Route
const DefaultRoute = '/Home'

const userData = getUserData()

const queryParams = new URLSearchParams(window.location.search)

const getContactsUrl = () => {
  return process.env.REACT_APP_ENGAGE_URL || `https://${process.env.REACT_APP_CRM_DOMAIN}/#/contacts/index?return_module=Contacts&return_action=DetailView`
}

const getAccountPathSrc = () => {
  const baseUrl = `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators/Edit/${userData?.AccountId}`
  const tab = queryParams.get('tab')
  

  switch (tab) {
    case 'companydetails':
      return `${baseUrl}?tab=identity#operator`
    case 'identities':
      return `${baseUrl}?tab=identity#identities`
    default:
      return baseUrl
  }
}

// ** Merge Routes
const Routes = [
  {
    path: '/*',
    component: lazy(() => import('@src/views/pages/IFramedContent')),
    iframeConfigs: [
      {
        id: 'contacts',
        path: '/Contacts',
        src: getContactsUrl()
      },
      {
        id: 'trips-board',
        path: '/Contacts/Trips',
        src: process.env.REACT_APP_ENGAGE_PIPELINE_URL,
        action: 'read',
        resource: 'trip-pipeline'
      },
      {
        id: 'workflow-builder',
        path: '/Workflow/Create',
        src: `${(process.env.REACT_APP_WETU_UI_URL || 'https://wetu.localhost.wetu.com:3002').replace(/\/$/, '')}/workflow/create`
      },
      {
        id: 'profiles',
        path: '/Profiles',
        src: `${process.env.REACT_APP_PROFILE_UI_URL}/home`
      },
      {
        id: 'profiles-edit-details',
        path: '/Profiles/edit/details',
        src: `${process.env.REACT_APP_PROFILE_UI_URL}/edit/details`
      },
      {
        id: 'profiles-edit-sustainability',
        path: '/Profiles/edit/sustainability',
        src: `${process.env.REACT_APP_PROFILE_UI_URL}/edit/sustainability?${queryParams.toString()}`
      },
      {
        id: 'specials-manager',
        path: '/SpecialsManager',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Specials`
      },
      {
        id: 'specials-portal',
        path: '/Specials/Search',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Specials/Search`
      },
      {
        id: 'itinerary-builder',
        path: '/ItineraryBuilder',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder`
      },
      {
        id: 'itinerary-builder-personal',
        path: '/ItineraryBuilder/Personal',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/Personal`
      },
      {
        id: 'itinerary-builder-sample',
        path: '/ItineraryBuilder/Sample',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/Sample`
      },
      {
        id: 'itinerary-builder-day-component',
        path: '/ItineraryBuilder/DayComponent',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/DayComponent`
      },
      {
        id: 'itinerary-builder-multiday-component',
        path: '/ItineraryBuilder/MultiDayComponent',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/Component`
      },
      {
        id: 'itinerary-builder-daytours',
        path: '/ItineraryBuilder/DayTours',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/DayTour`
      },
      {
        id: 'itinerary-builder-multidaytours',
        path: '/ItineraryBuilder/MultiDayTours',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/MultiDayTours`
      },
      {
        id: 'itinerary-builder-pubdaytours',
        path: '/ItineraryBuilder/PublishedDayTours',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/PublishedDayTours`
      },
      {
        id: 'itinerary-builder-pubmultidaytours',
        path: '/ItineraryBuilder/PublishedMultiDayTours',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Browse/PublishedMultiDayTours`
      },
      {
        id: 'calendar',
        path: '/Calendar',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Calendar`
      },
      {
        id: 'analytics',
        path: '/Analytics',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Home/AnalyticsContent`
      },
      {
        id: 'catalogue-manager',
        path: '/Catalogue',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Rack/Build/Catalogue`
      },
      {
        id: 'personal-details',
        path: '/PersonalDetails',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Users/Edit/${userData?.UserId}?isPersonalDetails=true`
      },
      {
        id: 'status-page',
        path: '/StatusPage',
        src: `https://status.${process.env.REACT_APP_MONOLITH_URL}/`
      },
      {
        id: 'account',
        path: '/Account',
        src: getAccountPathSrc()
      },
      {
        id: 'connect-bookings',
        path: '/Connect',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Connect`
      },
      {
        id: 'wetu-accounts-operators',
        path: '/Operators',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=operators`
      },
      {
        id: 'wetu-accounts-products',
        path: '/Products',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=products`
      },
      {
        id: 'marketers',
        path: '/Marketers',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=marketers`
      },
      {
        id: 'travel-agents',
        path: '/TravelAgents',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=travelagents`
      },
      {
        id: 'micro-operators',
        path: '/MicroOperators',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=micro`
      },
      {
        id: 'trials',
        path: '/Trials',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=trials`
      },
      {
        id: 'search',
        path: '/Search',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=find`
      },
      {
        id: 'reports-tools',
        path: '/ReportsAndTools',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators?tab=reports`
      },
      {
        id: 'ibrochure-search',
        path: '/iBrochure/Search',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Home/IBrochure_Search`
      },
      {
        id: 'product-manager',
        path: '/ProductManager',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/ConsultantPortal`
      },
      // The new Product Manager (ui_hub), beside the legacy one until it's complete.
      // Its iframe src is built from the dashboard's ?view=… in IFramedContent.
      // Left out where the environment has no URL for it yet.
      ...(process.env.REACT_APP_PRODUCT_MANAGER_URL ? [
        {
          id: 'new-product-manager',
          path: '/NewProductManager',
          src: process.env.REACT_APP_PRODUCT_MANAGER_URL,
          action: 'read',
          resource: 'new-product-manager'
        }
      ] : []),
      {
        id: 'themes',
        path: '/Themes',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Admin/Operators/Edit/${userData?.AccountId}?tab=themes&hideTabs=true#themes`,
        action: 'read',
        resource: 'themes'
      },
      {
        id: 'itinerary-builder-personal-create',
        path: '/ItineraryBuilder/Personal/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/Personal/ItineraryDetails`  
      },
      {
        id: 'itinerary-builder-sample-create',
        path: '/ItineraryBuilder/Sample/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/Sample/ItineraryDetails`  
      },
      {
        id: 'itinerary-builder-day-component-create',
        path: '/ItineraryBuilder/DayComponent/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/DayComponent/ComponentDetails`
      },
      {
        id: 'itinerary-builder-multiday-component-create',
        path: '/ItineraryBuilder/MultiDayComponent/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/Component/ComponentDetails`
      },
      {
        id: 'itinerary-builder-daytours-create',
        path: '/ItineraryBuilder/DayTours/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/DayTour/ItineraryDetails`
      },
      {
        id: 'itinerary-builder-multidaytours-create',
        path: '/ItineraryBuilder/MultiDayTours/Build',
        src: `https://${process.env.REACT_APP_MONOLITH_URL}/Builder/Build/MultiDayTours/ItineraryDetails`
      },
      //Keep this last to avoid the spinner bug.
      {
        id: 'home',
        path: '/Home',
        src: <Dashboard />  
      },
      {
        id: 'notifications',
        path: '/notifications',
        element: <NotificationsPage />
      }
    ]
  }
]

export { DefaultRoute, TemplateTitle, Routes }